module.exports = __webpack_public_path__ + "static/media/user5.6370bb82.png";